import { PieceSlider, PieceDescription, PieceUnorderedList, PieceSyntaxHighlighter, PieceTable, PieceFormula } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const linearRegressionAnalysis = {
    name: 'Multivariate Linear Regression Analysis',
    slug: 'linear-regression-analysis',
    description: 'Predict lending interest rate using multivariate linear regression analysis',
    cover: `${PUBLIC_URL}/blog/linear-regression-analysis/scatter-matrix.png`,
    clipPath: '14% 2%, 22% 2%, 22% 92%, 14% 93%',
    tech: ['AI', 'Python', 'statsmodels', 'Scatterplot Matrix'],
    pieces: [
        {
            type: 'table',
            title: 'Data example',
            tableProps: {
                showPagination: false,
            },
            header: [{
                Header: 'Purpose',
                accessor: 'purpose'
            }, {
                Header: 'Interest Rate',
                accessor: 'int_rate'
            }, {
                Header: 'Installment',
                accessor: 'installment'
            }, {
                Header: 'Annual income',
                accessor: 'annual_inc'
            }, {
                Header: 'DTI',
                accessor: 'dti'
            }, {
                Header: 'FICO',
                accessor: 'fico'
            }],
            data: [
                {
                  "fico": 707,
                  "purpose": "credit_card",
                  "int_rate": 0.1071,
                  "installment": 228.22,
                  "annual_inc": 11.08214255,
                  "dti": 14.29
                },
                {
                  "fico": 682,
                  "purpose": "debt_consolidation",
                  "int_rate": 0.1357,
                  "installment": 366.86,
                  "annual_inc": 10.37349118,
                  "dti": 11.63
                },
                {
                  "fico": 712,
                  "purpose": "debt_consolidation",
                  "int_rate": 0.1008,
                  "installment": 162.34,
                  "annual_inc": 11.35040654,
                  "dti": 8.1
                },
                {
                  "fico": 667,
                  "purpose": "credit_card",
                  "int_rate": 0.1426,
                  "installment": 102.92,
                  "annual_inc": 11.29973224,
                  "dti": 14.97
                },
                {
                  "fico": 727,
                  "purpose": "credit_card",
                  "int_rate": 0.0788,
                  "installment": 125.13,
                  "annual_inc": 11.90496755,
                  "dti": 16.98
                },
                {
                  "0": 1,
                  "fico": 667,
                  "purpose": "debt_consolidation",
                  "int_rate": 0.1496,
                  "installment": 194.02,
                  "annual_inc": 10.71441777,
                  "dti": 4
                },
                {
                  "0": 1,
                  "fico": 722,
                  "purpose": "all_other",
                  "int_rate": 0.1114,
                  "installment": 131.22,
                  "annual_inc": 11.00209984,
                  "dti": 11.08
                },
                {
                  "fico": 682,
                  "purpose": "home_improvement",
                  "int_rate": 0.1134,
                  "installment": 87.19,
                  "annual_inc": 11.40756495,
                  "dti": 17.25
                },
                {
                  "fico": 707,
                  "purpose": "debt_consolidation",
                  "int_rate": 0.1221,
                  "installment": 84.12,
                  "annual_inc": 10.20359214,
                  "dti": 10
                },
                {
                  "fico": 677,
                  "purpose": "debt_consolidation",
                  "int_rate": 0.1347,
                  "installment": 360.43,
                  "annual_inc": 10.4341158,
                  "dti": 22.09
                },
                {
                  "fico": 662,
                  "purpose": "debt_consolidation",
                  "int_rate": 0.1324,
                  "installment": 253.58,
                  "annual_inc": 11.83500896,
                  "dti": 9.16
                },
                {
                  "fico": 767,
                  "purpose": "debt_consolidation",
                  "int_rate": 0.0859,
                  "installment": 316.11,
                  "annual_inc": 10.93310697,
                  "dti": 15.49
                },
                {
                  "fico": 747,
                  "purpose": "small_business",
                  "int_rate": 0.0714,
                  "installment": 92.82,
                  "annual_inc": 11.51292546,
                  "dti": 6.5
                },
                {
                  "fico": 727,
                  "purpose": "debt_consolidation",
                  "int_rate": 0.0863,
                  "installment": 209.54,
                  "annual_inc": 9.487972109,
                  "dti": 9.73
                },
                {
                  "fico": 702,
                  "purpose": "major_purchase",
                  "int_rate": 0.1103,
                  "installment": 327.53,
                  "annual_inc": 10.73891524,
                  "dti": 13.04
                },
                {
                  "fico": 672,
                  "purpose": "all_other",
                  "int_rate": 0.1317,
                  "installment": 77.69,
                  "annual_inc": 10.52277288,
                  "dti": 2.26
                },
                {
                  "fico": 797,
                  "purpose": "credit_card",
                  "int_rate": 0.0894,
                  "installment": 476.58,
                  "annual_inc": 11.60823564,
                  "dti": 7.07
                },
                {
                  "fico": 712,
                  "purpose": "debt_consolidation",
                  "int_rate": 0.1039,
                  "installment": 584.12,
                  "annual_inc": 10.49127422,
                  "dti": 3.8
                },
                {
                  "fico": 667,
                  "purpose": "major_purchase",
                  "int_rate": 0.1513,
                  "installment": 173.65,
                  "annual_inc": 11.00209984,
                  "dti": 2.74
                },
                {
                  "fico": 772,
                  "purpose": "all_other",
                  "int_rate": 0.08,
                  "installment": 188.02,
                  "annual_inc": 11.22524339,
                  "dti": 16.08
                }
              ]
        } as PieceTable,
        {
            type: 'syntax highlighter',
            language: 'html',
            code: 
`CSV file with full data can be accessed here:
${PUBLIC_URL}/blog/linear-regression-analysis/loan_data.csv`
        } as PieceSyntaxHighlighter,
        {
            type: 'description',
            description: `Let\'s say you have a task where you have to predict lending interest rate charged to the borrower having the data above. First, import data:`,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`import pandas as pd
import numpy as np
import statsmodels.api as sm
loansData = pd.read_csv('loan_data.csv')`
        } as PieceSyntaxHighlighter,
        {
            type: 'description',
            description: `In order to be able to understand which fields from the CSV file affects seeking interest rate we have to build Scatterplot Matrix first. For reference <a href="https://en.wikipedia.org/wiki/Scatter_plot">https://en.wikipedia.org/wiki/Scatter_plot</a>`,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`pd.plotting.scatter_matrix(loansData,figsize=(15,15),diagonal='kde')`
        } as PieceSyntaxHighlighter,
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/blog/linear-regression-analysis/scatter-matrix.png`,
                },
            ]
        } as PieceSlider,
        {
            type: 'description',
            description: `If you pay attention "int.rate" does not depend on ["credit.policy", "revol.bal", "inq.last.6mths", "delinq.2yrs", "pub.rec", "not.fully.paid"]. It doesn't depend because for each different "int.rate" value corresponds almost the same value from mentioned columns. Thus we can skip these columns.
            For the rest columns we are going to create linear model using <a href="https://www.statsmodels.org/dev/generated/statsmodels.regression.linear_model.OLS.html">OLS from statsmodels</a>`,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`interestRate = loansData['int.rate']
installment = loansData['installment']
logAnnualInc = loansData['log.annual.inc']
dti = loansData['dti']
fico = loansData['fico']
daysWithCrLine = loansData['days.with.cr.line']
revolUtil = loansData['revol.util']

y = np.matrix(interestRate).transpose()
x1 = np.matrix(installment).transpose()
x2 = np.matrix(logAnnualInc).transpose()
x3 = np.matrix(dti).transpose()
x4 = np.matrix(fico).transpose()
x5 = np.matrix(daysWithCrLine).transpose()
x6 = np.matrix(revolUtil).transpose()

x = np.column_stack([x1,x2,x3,x4,x5,x6])
# create a linear model
X = sm.add_constant(x)
model = sm.OLS(y,X)
f = model.fit()

print ("pvalues = %s, rsquared = %s" % (f.pvalues, f.rsquared))
print ("Intercept = %s, Coefficients = %s" % (f.params[2], f.params[0:2]))`
        } as PieceSyntaxHighlighter,
        {
            type: 'description',
            description: 
            `P-Values are probabilities. The convention is it needs to be 0.05 or less:
            <br/>
            <a href="https://en.wikipedia.org/wiki/P-value">https://en.wikipedia.org/wiki/P-value</a>
            <br/>
            R-squared is a measure of how much of the variance in the data is captured by the model. A high R-squared would be close to 1.0 a low one would be close to 0. The value we've got = 0.63, is a good one.
            <br/>
            <a href="https://en.wikipedia.org/wiki/Coefficient_of_determination">https://en.wikipedia.org/wiki/Coefficient_of_determination</a>
            <br/>
            Trying to decrease number of depended variables (currently we've got 6) and keeping eye on P-Values and R-squared we end up with x1 and x4 will produce almost the same values be had before.
            `,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`x = np.column_stack([x1,x4])`
        } as PieceSyntaxHighlighter,
        {
            type: 'formula',
            title: 'Formula',
            formula: `$$InterestRate = a_0 + a_1 * Installment + a_2 * Fico$$`,
        } as PieceFormula,
        {
            type: 'description',
            description: `where <i>a0</i> is the Interceptor and <i>a1</i>, <i>a2</i> are Coefficients for Installment and Fico respectively. Thank you for reading to the end :)`,
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Technologies',
            items: ['Python', 'statsmodels', 'Scatterplot Matrix'],
        } as PieceUnorderedList
    ],
}

export default linearRegressionAnalysis;


// WEBPACK FOOTER //
// ./src/store/blog/linear-regression-analysis.tsx